import { useAssets } from "./useAssets";

export function useImageAssets(enabled: boolean) {
  return useAssets(enabled, "image");
}
